import { Component, createRef, Fragment, h } from 'preact';
import ReactHintFactory from 'react-hint';
import { PROVISIONS, DEFAULT_POWERED_BY_TEXT, DEFAULT_POWERED_BY_NEW_TAB_TEXT } from '../../../common/constants';
import QuestionIcon from '../QuestionIcon.js';
import {
  StyledFooterDiv,
  StyledPoweredByLogoImage,
  StyledPoweredByAnchorTag,
} from './StyledFooter';
const ReactHint = ReactHintFactory({ createElement: h, Component });
const MEDALLIA_LOGO_PATH =
  'assets/images/kampyle/CommandCenterInvitationLogo.svg';
export default class FooterSection extends Component {
  constructor(props) {
    super(props);
    this.iconElemRef = createRef();
    this.getInviteLogoUrl = this.getInviteLogoUrl.bind(this);
  }

  getInviteLogoUrl() {
    if (window.kplConfig) {
      return `${window.kplConfig.prefix}${window.kplConfig.resourcesPrefix}${MEDALLIA_LOGO_PATH}`;
    } else {
      return `${this.props.globalResourcesUrl}/CommandCenterInvitationLogo.svg`;
    }
  }

  getPoweredByClasses() {
    const legacyV1Class = 'powered-by-link link-text link-text-color';

    return `${legacyV1Class} ${
      this.props.isWCAG ? 'neb-wcag wcag-powered-by-contrast' : ''
    }`;
  }

  getHelpLinkClasses() {
    return `question-circle kpl-tooltip kpl-invitation-tooltip pull-left ${
      this.props.isWCAG ? 'neb-wcag' : ''
    }`;
  }

  renderPoweredByLogo() {
    const { isDirectionRtl, isWCAG, poweredByTranslation, poweredByNewTabTranslation, isInviteReflow } = this.props;
    const medalliaLogo = this.getInviteLogoUrl();
    const PoweredByText = poweredByTranslation || DEFAULT_POWERED_BY_TEXT;
    const PoweredByNewTabTranslation = poweredByNewTabTranslation || DEFAULT_POWERED_BY_NEW_TAB_TEXT

    return (<StyledPoweredByAnchorTag
        target="_blank"
        href="https://www.medallia.com"
        isWCAG={isWCAG}
        isDirectionRtl={isDirectionRtl}
        dir={isDirectionRtl ? 'rtl' : 'ltr'}
        aria-label={`${PoweredByText} Medallia ${PoweredByNewTabTranslation}`}
        className={this.getPoweredByClasses()}
        isInviteReflow={isInviteReflow}
      >
        {PoweredByText}
        <StyledPoweredByLogoImage
          src={medalliaLogo}
          className="footerImg powered-by-image"
          role="presentation"
          isInviteReflow={isInviteReflow}
        />
      </StyledPoweredByAnchorTag>);
  }

  renderQuestionTooltip({ toolTipText, provisions, isDirectionRtl, isInviteReflow, horizontal }) {
    return !toolTipText ? null : (
      <Fragment>
        <ReactHint
          position={isDirectionRtl ? 'left' : 'right'}
          events
          isInviteReflow={isInviteReflow}
          horizontal={horizontal}
        />
        <QuestionIcon
          ref={this.iconElemRef}
          toolTipText={toolTipText || null}
          className={this.getHelpLinkClasses()}
          isDirectionRtl={isDirectionRtl}
          isInviteReflow={isInviteReflow}
        />
      </Fragment>
    )
  }

  render() {
    const {
      isDirectionRtl,
      isWCAG,
      isInviteReflow,
      horizontal,
      visibility,
    } = this.props;

    return (
      <StyledFooterDiv
        isWCAG={isWCAG}
        isDirectionRtl={isDirectionRtl}
        className="footerCls"
        isInviteReflow={isInviteReflow}
        horizontal={horizontal}
        visibility={visibility}
      >
        {isInviteReflow ? (
          <div className='tooltip-container'>
            {this.renderQuestionTooltip(this.props)}
          </div>
        ) : this.renderQuestionTooltip(this.props)
        }
        {this.renderPoweredByLogo()}
      </StyledFooterDiv>
    );
  }
}

FooterSection.defaultProps = {
  provisions: {},
};
